import { createAction, createSlice } from "@reduxjs/toolkit";
import { Message } from "../../@types/message";
import { User } from "../../@types/user";
import { findMessages } from "./actions/findMessages";
import { createUser } from "../userCreate/actions/createUser";
import findUsers from "./actions/findUsers";
import {findSourceOrganization} from "./actions/findSourceOrganization"
import reloadSO from "../userAuthentication/actions/reloadSourceOrganization";

interface UsersState {
  users: User[];
  messages: Message[];
  fetchMessagesStatus: string;
  searchText: string;
  sourceOrganizations: any[];
}

const initialState = {
  users: [],
  messages: [],
  fetchMessagesStatus: "",
  searchText: "",
  sourceOrganizations:[],
} as UsersState;

export const setSearchText = createAction<string>("SET_SEARCH_TEXT");
export const resetUsersState = createAction("RESET_USERS_STATE");

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findUsers.fulfilled, (state, { payload }) => {
        const newUsers = payload;
        const existingUsers = state.users;
        const mergedUsers = [...existingUsers, ...newUsers];

        // Remove duplicates from mergedUsers array based on user id
        const uniqueUsers = mergedUsers.filter(
          (user, index, self) => index === self.findIndex((u) => u.id === user.id)
        );

        return {
          ...state,
          status: "succeeded",
          users: uniqueUsers,
        };      })
      .addCase(setSearchText, (state, { payload }) => {
        state.searchText = payload;
      })
      .addCase(findMessages.pending, (state) => {
        state.fetchMessagesStatus = "pending";
      })
      .addCase(findMessages.fulfilled, (state, { payload }) => {
        state.messages = payload;
        state.fetchMessagesStatus = "succeeded";
      })
      .addCase(createUser.fulfilled, (state, { payload }) => {
        state.users.push(payload);
      })
      .addCase(findSourceOrganization.fulfilled, (state, { payload }) => {
        state.sourceOrganizations = payload
      })
      .addCase(reloadSO.fulfilled, (state, { payload }) => {
        state.users = [];
        state.messages = [];
        state.searchText = "";
      })
      .addCase(resetUsersState, () => initialState)
      ;
  },
});

export default usersSlice.reducer;
